function getDateValidationError(value, minimum, maximum) {
    if (value === '' || value === null || value === undefined) {
        return '';
    }

    const message = `Enter a valid date between ${minimum} and ${maximum} in YYYY-MM-DD format.`;
    if (typeof value !== 'string' || !/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value)) {
        return message;
    }

    if (value < minimum || value > maximum) {
        return message;
    }

    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(0);
    date.setUTCFullYear(year, month - 1, day);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
        return message;
    }

    return '';
}

module.exports = { getDateValidationError };
